const jumplinkContainer = document.querySelector('.jumplinks-801');
const scrollLink = document.querySelectorAll('.jumplinks-801 a[href^="#"]');
const sectionStatus = document.querySelector('.jumplinks-801__status');
let copyLinkButtonClicked = false;
let copyLinkIcon = document.querySelector('.jumplinks-801 .copy-link-icon');
let mainMenu = document.querySelector('header.header__position');
let headerHeight = document.querySelector('.header-wrapper').clientHeight + "px";
let headerTransition = document.querySelector('header.header__position').style.top;

scrollLink.forEach(item => {
    let linkHash = item.hash.replace(/#/g, "").toLowerCase();
    item.hash = linkHash;
});

const addScrollMargin = () => {
    const mediaQuery = window.matchMedia('(min-width: 992px)')
    let headerHeight = document.querySelector('.header-wrapper').clientHeight + "px";
    let mobileAdjuster = document.querySelector('.header-wrapper').clientHeight + document.querySelector('.jumplinks-801__status').clientHeight + "px";
    scrollLink.forEach(item => {
        let linkHash = item.hash.replace(/#/g, "");
        let blockItem = document.getElementById(linkHash);
        if (blockItem == null || blockItem.length == 0) {
            return false;
        }
        else {
            blockItem.style.setProperty("scroll-margin-top", `${mobileAdjuster}`);
            // Check if the media query is true
            if (mediaQuery.matches) {
                blockItem.style.setProperty("scroll-margin-top", `${headerHeight}`);
            }
        }
    });
}

//Start of function for checking and scrolling to has in url
window.addEventListener('DOMContentLoaded', function () {

    if (window.location.hash == '') {
        return false;
    }

    let el = document.querySelector(window.location.hash);

    if (el !== null) {

        el.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            duration: 800 // how long to animate
        });

        setTimeout(function () { // patch animation
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                duration: 200 // how long to patch
            });
        }, 1200); // how long to wait before patching

    }

}, false);

//End of function for checking and scrolling to has in url


//Start of function clicking to copy url

if (copyLinkIcon != null) {
    copyLinkIcon.addEventListener('click', (event) => {

        let copySuccessMessage = copyLinkIcon.getAttribute('data-copy-url-success');
        let copyUrl = copyLinkIcon.getAttribute('data-canonical-link');
        if (!copyLinkButtonClicked) {
            copyLinkButtonClicked = true;
            let fadeOut = document.createElement("div");
            fadeOut.setAttribute("class", "fadeout-copy-confirmation");
            fadeOut.setAttribute("style", "position: absolute; user-select: none; background-color: #fff; padding: 2px 4px; font-size: 1.2rem; border: 1px solid black; z-index: 999; transition: 1.5s; left: " + event.pageX + "px; top: " + event.pageY + "px;");

            document.getElementsByTagName("body")[0].append(fadeOut);
            fadeOut.innerHTML = copySuccessMessage;
            window.setTimeout(function () {
                fadeOut.setAttribute('style', 'opacity: 0');
                window.setTimeout(function () {
                    fadeOut.remove();
                    copyLinkButtonClicked = false;
                }, 1500);
            }, 500);
        }
        navigator.clipboard.writeText(copyUrl);
    });
}

//End of function clicking to copy url


//Start of function clicking mobile status indicator to toggle open class
sectionStatus.addEventListener('click', (x) => {
    x.preventDefault;
    sectionStatus.classList.toggle('open');
});
//End of function clicking mobile status indicator to toggle open class

//Start of function clicking any jumplink and scrolling to its ID
scrollLink.forEach(item => {
    item.addEventListener('click', (e) => {
        let section = document.querySelector(item.hash);
        if (section == null || section.length == 0) {
            e.preventDefault();
            return false;
        }
        else {
            let targetBlock = document.querySelector(e.target.hash);
            e.preventDefault();
            targetBlock.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                duration: 800 // how long to animate

            });

            setTimeout(function () { // patch animation
                targetBlock.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    duration: 200 // how long to patch
                });
            }, 600); // how long to wait before patching
            sectionStatus.classList.remove('open');
        }
    });

});

//End of function clicking any jumplink and scrolling to its ID

//Start of function highlighting the active jumplink based on a section ID in view
const highlightNavigation = () => {
    let fromTop = window.scrollY - 50;
    let activeFrame = window.innerHeight * .3;
    let headerTransition = document.querySelector('header.header__position').style.top;
    let jumpLinknav = document.querySelector('.jumplinks-801');

    if (headerTransition > -1 + "px" && window.innerWidth >= 992) {
        jumpLinknav.style.setProperty('top', '-100px');
    }

    scrollLink.forEach(link => {

        let section = document.querySelector(link.hash);
        let activeSection = document.querySelector('.jumplinks-801 a.active').innerHTML;

        if (section == null || section.length == 0) {
            return false;
        }
        else if (
            section.offsetTop <= fromTop + activeFrame &&
            section.offsetTop + section.offsetHeight > fromTop + activeFrame
        ) {
            scrollLink.forEach(links => {
                links.classList.remove("active");
            })
            link.classList.add("active");
            sectionStatus.innerHTML = activeSection;
        }
    });
};
//End of function highlighting the active jumplink based on a section ID in view

//Start of function to change the 801 to a different layout when if class is present
const stickyNav = () => {
    if (window.scrollY > jumplinkContainer.offsetTop) {
        jumplinkContainer.classList.add('sticky-jumplinks');
    } else {
        jumplinkContainer.classList.remove('sticky-jumplinks');
    }
}

//END of function to change the 801 to a different layout when if class is present


//Start of function that looks for any update to the header styling to affix the jumplink container to bottom
const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'style') {
            let headerHeight = document.querySelector('.header-wrapper').clientHeight + "px";
            let headerTransition = document.querySelector('header.header__position').style.top;
            jumplinkContainer.style.setProperty('top', `calc(${headerHeight} + (${headerTransition}) - 1px)`);
        }
    });
});

// Notify me of style changes
let observerConfig = {
    attributes: true,
    attributeFilter: ["style"]
};

//END of function that looks for any update to the header styling to affix the jumplink container to bottom


observer.observe(mainMenu, observerConfig);


window.addEventListener('scroll', function (event) {
    addScrollMargin();
    highlightNavigation();
    stickyNav();
});

window.addEventListener('resize', function (event) {
    addScrollMargin();
    stickyNav();
    highlightNavigation();
    sectionStatus.classList.remove('open');
});

window.addEventListener('DOMContentLoaded', function (event) {
    addScrollMargin();
    stickyNav();
    highlightNavigation();
}); 
